import React from "react";
import { styled } from "@mui/system";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Utilisation de styled pour appliquer les styles au composant TreeView
const TreeViewStyled = styled(TreeView)(({ theme }) => ({
  height: 240,
  flexGrow: 1,
  maxWidth: 400,
}));

export default function Treeview(props) {
  const { categories = {}, onSelectedNode, expanded } = props;

  console.log("categories", categories);

  const handleSelect = (event, nodeId) => {
    onSelectedNode && onSelectedNode(nodeId);
  };

  // Utiliser un Set pour tracker les IDs déjà utilisés et éviter les doublons
  const usedIds = new Set();

  const loopAndDisplayNode = (node, parentPath = "") => {
    if (!node || !node.id) return null;

    // Créer un ID unique en combinant le chemin parent avec l'ID actuel
    const uniqueId = parentPath ? `${parentPath}-${node.id}` : `${node.id}`;

    // Si l'ID a déjà été utilisé, ne pas rendre ce noeud pour éviter l'erreur
    if (usedIds.has(uniqueId)) {
      console.warn(
        `Duplicate node ID detected: ${node.id} at path ${parentPath}`
      );
      return null;
    }

    usedIds.add(uniqueId);

    return (
      <TreeItem
        itemId={uniqueId}
        key={uniqueId}
        nodeid={uniqueId}
        label={`${node.id}-${node.label}`}
      >
        {(node.children || []).length > 0
          ? node.children.map((n) => loopAndDisplayNode(n, uniqueId))
          : null}
      </TreeItem>
    );
  };

  if (!categories || !categories.id) {
    return null;
  }

  return (
    <TreeViewStyled
      expanded={expanded}
      onNodeSelect={handleSelect}
      defaultcollapseicon={<ExpandMoreIcon />}
      defaultexpandicon={<ChevronRightIcon />}
    >
      {loopAndDisplayNode(categories)}
    </TreeViewStyled>
  );
}
